/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const Pricing = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="pricing">
      <span className="section-link"></span>
      <h2 className="head text-capitalize text-center">{project} - Pricing</h2>
      <div className="pricing-div text-center">
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>2 BHK</h3>
          <h4>745 Sq. ft.</h4>
          <button
            className="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>3 BHK</h3>
          <h4>1053 Sq. ft.</h4>
          <button
            className="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>
            3 BHK <small style={{ fontSize: "1rem" }}>(Large)</small>{" "}
          </h3>
          <h4>1240 Sq. ft.</h4>
          <button
            className="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
      </div>
      {/* <small
        className="d-block text-center"
        style={{ cursor: "pointer" }}
        onClick={() => handleShowModal("Price Breakup")}
      >
        Pre-launch pricing available for a limited time - Enquire now!
      </small> */}
    </section>
  );
};

export default Pricing;
